<template>
  <div class="gallery">
    <v-carousel v-model="currentSlide" :show-arrows="'hover'" hide-delimiters>
      <v-carousel-item
        v-for="(image, index) in images"
        :key="index"
        :src="imageUrl(image)"
        contain
        @click="openZoom(index)"
        class="zoomable-slide"
      ></v-carousel-item>
    </v-carousel>
    <div class="zoom-hint" @click="openZoom(currentSlide)">
      <v-icon size="22" icon="mdi-magnify-plus-outline" color="#BD9478" />
    </div>
    <div class="thumbnails">
      <img
        v-for="(image, index) in images"
        :key="index"
        :src="imageUrl(image)"
        alt="Thumbnail"
        @click="goToSlide(index)"
        class="thumbnail"
        :class="{ active: currentSlide === index }"
      />
    </div>
    <div class="gradient left" />
    <div class="gradient right" />

    <ImageZoomOverlay
      v-model="isZoomOpen"
      :images="images.map((img) => imageUrl(img))"
      :initialIndex="zoomIndex"
    />
  </div>
</template>

<script>
import config from "../../config";
import ImageZoomOverlay from "./ImageZoomOverlay.vue";

export default {
  components: {
    ImageZoomOverlay,
  },
  data() {
    return {
      currentSlide: 1,
      isZoomOpen: false,
      zoomIndex: 0,
    };
  },
  props: {
    images: {
      type: Array,
      required: true,
    },
    mainImage: {
      type: Number,
      required: false,
    },
  },
  mounted() {
    this.currentSlide = this.mainImage;
  },
  methods: {
    imageUrl(image) {
      if (image && image?.startsWith("http")) {
        return image;
      } else {
        return `${config.baseURL}${image}`;
      }
    },
    goToSlide(index) {
      this.currentSlide = index;
    },
    openZoom(index) {
      this.zoomIndex = index;
      this.isZoomOpen = true;
    },
  },
};
</script>
<style lang="scss">
.btn-left,
.btn-right {
  background: #ffffff69;
  box-shadow: unset !important;
}
.btn-right {
  left: 10px;
}
.btn-left {
  right: 10px;
}
.gradient {
  position: absolute;
  height: 60px;
  width: 60px;
  bottom: 0px;
  &.left {
    background-image: linear-gradient(270deg, #ff000000, #ffffff);
    left: 0px;
  }
  &.right {
    background-image: linear-gradient(90deg, #ff000000, #ffffff);
    right: 0px;
  }
}
.thumbnails {
  display: flex;
  justify-content: center;
  overflow-x: scroll;
  margin-top: 10px;
  &::-webkit-scrollbar {
    display: none;
  }
}
.thumbnail {
  width: 60px;
  height: 60px;
  margin: 0 5px;
  cursor: pointer;
  object-fit: cover;
  &.active {
    border: 2px solid $primaryColor;
  }
}

.zoomable-slide {
  cursor: zoom-in;
}

.zoom-hint {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 2;
  background: rgba(255, 255, 255, 0.92);
  border: 1.5px solid #BD9478;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: scale(1.12);
    box-shadow: 0 4px 14px rgba(189, 148, 120, 0.4);
  }
}
</style>
